module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-2.1-R-003.c5c13cbd.json").toString();